

/**
 * @classdesc Décrit la class
 * @kind class
 * @export
 * @class MyClass
 */
export default class Equipe {
    id;
    id_course;
    uid = "";
    nom = "";
    coureurs = [];
    extra_fields = [];


    /**
     * Creates an instance of MyClass.
     * @constructs
     * @kind function
     * @memberof Equipe
     */
    constructor() { }



    set(data) { }

    get_entete(i) {
        const index = i + 1;
        return "Equipe n°" + index + " - " + this.nom;
    }

    get_readable_name() {
        if (!this.nom) return 'Equipe sans nom';
        return this.nom;
    }

    set_extra_fields(base, existing_fields) {
        if (base && base == 'ENR24') {
            let name_field = { "label": "Nom de l'entreprise", "name": "nom_entreprise_ENR24", "type": "text", "required": true, "value": "" };
            if (existing_fields.nom_entreprise_ENR24) {
                name_field.value = existing_fields.nom_entreprise_ENR24;
            }
            this.extra_fields.push(name_field);
            let address_field = { "label": "Adresse postale de l'entreprise", "name": "adresse_postale_entreprise_ENR24", "type": "text", "required": true, "value": "" };
            if (existing_fields.adresse_postale_entreprise_ENR24) {
                address_field.value = existing_fields.adresse_postale_entreprise_ENR24;
            }
            this.extra_fields.push(address_field);
            let siren_field = { "label": "SIREN de l'entreprise", "name": "siren_entreprise_ENR24", "type": "text", "required": true, "value": "" };
            if (existing_fields.siren_entreprise_ENR24) {
                siren_field.value = existing_fields.siren_entreprise_ENR24;
            }
            this.extra_fields.push(siren_field);
        }
    }

    has_complete_all_fields() {
        for (let i = 0; i < this.extra_fields.length; i++) {
            let field = this.extra_fields[i];
            if (field.required && (!field.value || field.value == "")) {
                return false;
            }
        }
        return true;
    }
}